import { api } from '@goaltree/backend/convex/_generated/api'
import { habitLevel } from '@goaltree/backend/convex/lib/progression'
import { useQuery } from 'convex/react'
import { useTranslation } from 'react-i18next'

import { GrowthSection } from '@/components/growth-section'
import { HabitIcon } from '@/components/habit-icon'

const card = 'flex flex-col gap-2.5 rounded-2xl border border-border/60 bg-card/40 p-4'

// Stats → Your progress: badges strip plus each habit's growth stage.
export function GrowthStats() {
  const { t } = useTranslation()
  const levels = useQuery(api.progression.getMyHabitLevels)
  const habits = useQuery(api.nodes.getHabits)
  const byId = new Map((habits ?? []).map((h) => [h._id as string, h]))
  const rows = (levels ?? [])
    .map((l) => ({ ...l, habit: byId.get(l.habitId as string), lvl: habitLevel(l.total) }))
    .filter((r) => r.habit)
    .sort((a, b) => b.total - a.total)

  return (
    <section className={card}>
      <GrowthSection />
      {rows.length > 0 && (
        <div className="mt-2 flex flex-col gap-2.5">
          <h2 className="text-[10px] font-bold uppercase tracking-[0.14em] text-foreground/40">
            {t('progression.habitLevels')}
          </h2>
          {rows.map(({ habitId, total, habit, lvl }) => (
            <div key={habitId} className="flex items-center gap-2.5">
              <HabitIcon habit={habit!} />
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline justify-between gap-2">
                  <p className="truncate text-sm text-foreground">{habit!.title.split('///')[0]}</p>
                  <span className="shrink-0 font-mono text-[11px] text-muted-foreground">
                    {t('progression.levelChip', {
                      name: t(`progression.level.${lvl.name}`),
                      level: lvl.level,
                    })}
                  </span>
                </div>
                <div className="mt-1 h-1 overflow-hidden rounded-full bg-muted">
                  <div
                    className="h-full rounded-full bg-primary/70 transition-[width] duration-700"
                    style={{
                      width: `${lvl.next === null ? 100 : Math.max(4, lvl.progress * 100)}%`,
                    }}
                  />
                </div>
                <p className="mt-0.5 text-[11px] text-muted-foreground">
                  {lvl.next === null
                    ? t('progression.levelMax')
                    : t('progression.levelNext', {
                        count: lvl.next - total,
                        name: t(`progression.level.${habitLevel(lvl.next).name}`),
                      })}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
